import { Button, Modal, RadioGroup } from "@ts-digital/vrc";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import SimpleLoader from "../general/loader";
import { startDownloadData } from "../../libs/utils";
import { exportDeadlinesCsv, sendDeadlinesEmail } from "../../store/actions/deadlines/export";
import moment from "moment";

const DialogExportDeadlines = (props) => {
  const { mode, status, setStatus, queryParameters } = props;

  const dispatch = useDispatch();
  const deadlinesCompany = useSelector((state) => state.deadlinesCompany);
  const [exportSelected, setExportSelected] = useState("download");

  const maxAllowerRows = 1000; // Massimo di righe consentite per il download istantaneo del csv.

  const onConfirm = () => {
    let newQueryParams = { ...queryParameters };
    delete newQueryParams["status"];
    newQueryParams.paymentStep = queryParameters?.status;
    if (exportSelected === "email") {
      dispatch(
        sendDeadlinesEmail(
          null, // myType === "STUDIO" ? companyUuidSelected : null,
          newQueryParams
        )
      ).then(() => {
        setStatus();
      });
    } else {
      dispatch(
        exportDeadlinesCsv(
          null, // myType === "STUDIO" ? companyUuidSelected : null,
          newQueryParams
        )
      ).then((res) => {
        startDownloadData({
          content: res,
          filename: `Esportazione del ${moment().format("DD/MM/YYYY")}.csv`,
        });
        setStatus();
      });
    }
  };

  return (
    <Modal
      visible={status === "waiting"}
      onClose={() => setStatus()}
      outsideClosable={false}
      footer={
        !deadlinesCompany.isExportingDeadlines && (
          <div className="dbx-export-deadlines-dialog-footer">
            <Button kind="secondary" onClick={() => setStatus()}>
              <FormattedMessage id="generic.cancel" />
            </Button>
            <Button
              onClick={() => {
                onConfirm();
              }}
            >
              <FormattedMessage id="generic.export" />
            </Button>
          </div>
        )
      }
      title={useIntl().formatMessage({ id: `deadlines.export.${mode}.title` })}
    >
      <div className={"dbx-export-deadlines-dialog-body" + (deadlinesCompany.isExportingDeadlines ? " hasSpinner" : "")}>
        {deadlinesCompany.isExportingDeadlines ? (
          <SimpleLoader />
        ) : (
          <React.Fragment>
            <div className="deadlines-export-choice">
              <RadioGroup
                value={exportSelected}
                type="vertical"
                options={[
                  {
                    label: useIntl().formatMessage({ id: `deadlines.export.${mode}.download` }, { num: <strong>{maxAllowerRows}</strong> }),
                    value: "download",
                  },
                  {
                    label: useIntl().formatMessage({
                      id: `deadlines.export.${mode}.email`,
                    }),
                    value: "email",
                  },
                ]}
                onChange={(e) => setExportSelected(e.target.value)}
              />
            </div>
            <div className="deadlines-export-tip">{useIntl().formatMessage({ id: `deadlines.export.${mode}.tip` })}</div>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

export default DialogExportDeadlines;
